<script>
    import { getContext } from 'svelte';
    import NewSubscription from './popups/NewSubscription/container.svelte';
    import NewSubscriptionForm from './popups/NewSubscription/content.svelte';
    export let addNewSubscription;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = () => {
          open(NewSubscription,
            {
                message: "create a new group",
            },
            {
                // closeButton: CloseButton,
                form: NewSubscriptionForm,
                propsForForm: [addNewSubscription]
            }
        );
      };
</script>

<button 
    class="new-subscription-button primary-green" 
    on:click={showPopup}>
        New Group
</button>